<template>
<v-container fluid class="fullscreen">
  <v-row no-gutters>
    <v-col cols="12" md="12" class="pa-2">
      <v-card>
        <v-card-title>
          <v-row no-gutters>
            <v-col cols="9">
              <v-row no-gutters>
                <v-col cols="12" md="4" class="px-2">
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="290px"
                    v-model="fromMenu"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="fromDateValue"
                        label="From Date"
                        prepend-icon="event"
                        hide-details
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :type="datePickerType"
                      v-model="fromDate"
                      @input="fromMenu = false"
                      :max="new Date().toISOString().substr(0, 10)"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="4" class="px-2">
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    min-width="290px"
                    v-model="toMenu"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="toDateValue"
                        label="To Date"
                        prepend-icon="event"
                        hide-details
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker :max="new Date().toISOString().substr(0, 10)" :type="datePickerType" v-model="toDate" @input="toMenu = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="10" md="4" class="px-2">
                  <v-select
                    label="Branch"
                    v-model="branch"
                    :items="listBranch"
                    prepend-icon="store"
                    item-text="branchName"
                    item-value="branchId"
                    hide-details
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-radio-group v-model="dateType" row hide-details>
                    <v-radio label="Day" value="date"></v-radio>
                    <v-radio label="Month" value="month"></v-radio>
                    <v-radio label="Year" value="year"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3" align="end" justify="end">
              <v-btn fab depressed small color="primary" @click="search">
                <v-icon>search</v-icon>
              </v-btn>
              <v-btn depressed fab small class="mx-1" color="primary" outlined>
                <v-icon>help</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12" class="pa-2 pt-0">
      <v-card>
        <v-card-title class="pa-0">
          <v-row no-gutters>
            <v-col cols="12" md="4" class="py-4 px-3">
              Profit And Loss Report
              <button icon type="button" v-on:click="onexport">
                <v-icon color="primary">assignment</v-icon>
              </button>
            </v-col>
            <v-col cols="12" md="5" offset-md="3" :hidden="profitAndLoss.profitLossList <= 0">
              <v-alert
                v-if="profitAndLoss.totalProfitLoss > 0"
                type="success"
                border="left"
                class="ma-2"
                dense
              >
                From {{ fromDateValue }} to {{ toDateValue }} : Profit =
                {{ profitAndLoss.totalProfitLoss | defaultPaymentFormat }}
              </v-alert>
              <v-alert class="ma-2" v-else dense border="left" type="error">
                From {{ fromDateValue }} to {{ toDateValue }} : Loss =
                {{ profitAndLoss.totalProfitLoss | defaultPaymentFormat }}
              </v-alert>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
      <v-row no-gutters class="pt-2">
        <v-col
          v-if="profitAndLoss.profitLossList.length == 0"
          class="text-center"
          cols="12"
        >No data available</v-col>
        <v-col
          v-for="profitAndLoss in profitAndLoss.profitLossList"
          :key="profitAndLoss.reportTitle"
          cols="12"
          md="3"
        >
          <v-card class="ma-1">
            <v-card-title class="primary white--text">
              {{
              profitAndLoss.reportTitle
              }}
            </v-card-title>
            <v-card-text class="pt-2 black--text">
              <v-row no-gutters>
                <v-col cols="10">
                  <h4>Gross Profit</h4>
                </v-col>
                <v-col class="text-right" cols="2">
                  {{
                  profitAndLoss.grossProfit
                  }}
                </v-col>
              </v-row>
              <template
                v-if="
                  profitAndLoss.incomeList != null &&
                    profitAndLoss.incomeList.length != 0
                "
              >
                <br />
                <h4>Income -</h4>
                <v-row no-gutters v-for="income in profitAndLoss.incomeList" :key="income.typeName">
                  <v-col cols="6">{{ income.typeName }}</v-col>
                  <v-col cols="6" class="text-right">
                    {{
                    income.amount | defaultPaymentFormat
                    }}
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="6">Total Income Price</v-col>
                  <v-col cols="6" class="text-right">
                    {{
                    profitAndLoss.totalIncomePrice | defaultPaymentFormat
                    }}
                  </v-col>
                </v-row>
              </template>
              <template
                v-if="
                  profitAndLoss.expenseList != null &&
                    profitAndLoss.expenseList.length != 0
                "
              >
                <br />
                <h4>Expense -</h4>
                <v-row no-gutters v-for="(income, index) in profitAndLoss.expenseList" :key="index">
                  <v-col cols="6">{{ income.typeName }}</v-col>
                  <v-col cols="6" class="text-right">
                    {{
                    income.amount | defaultPaymentFormat
                    }}
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="6">Total Expense Price</v-col>
                  <v-col cols="6" class="text-right">
                    {{
                    profitAndLoss.totalExpensePrice | defaultPaymentFormat
                    }}
                  </v-col>
                </v-row>
              </template>
              <v-divider />
              <v-row no-gutters>
                <v-col cols="6" v-if="profitAndLoss.profitLoss > 0">Profit</v-col>
                <v-col cols="6" v-else>Loss</v-col>
                <v-col cols="6" class="text-right">
                  {{
                  profitAndLoss.profitLoss | defaultPaymentFormat
                  }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  </v-container>
</template>
<script>
import profitAndLossService from "../service/ProfitAndLossService";
import branchService from "../service/BranchService";
import XLSX from "xlsx";
export default {
  mounted: function () {
    branchService.getAllBranch().then((data) => {
      this.listBranch = this.listBranch.filter((v) => false);
      this.listBranch.push({
        branchId: 0,
        branchName: "All",
      });
      this.listBranch.push(...data);
    });
  },
  data() {
    return {
      toDate: new Date().toISOString().substr(0, 10),
      fromDate: new Date().toISOString().substr(0, 10),
      toMenu: false,
      fromMenu: false,
      dateType: "date",
      datePickerType: "date",
      listBranch: [],
      branch: 0,
      profitAndLoss: {
        totalProfitLoss: 0,
        profitLossList: [],
      },
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (this.dateType == "date") {
        // const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      } else if (this.dateType == "month") {
        // const [year, month, day] = date.split("-");
        return `${month}-${year}`;
      } else {
        // const [year, month, day] = date.split("-");
        return `${year}`;
      }
    },
    formatDateUrl(date) {
      //if (!date) return null;
      if (this.dateType == "month") {
        const [month, year] = date.split("-");
        return `01-${month}-${year}`;
      } else if (this.dateType == "year") {
        const [year] = date.split("-");
        return `01-01-${year}`;
      }
      return date;
    },
    search: function () {
      let request = [];
      let fDate = this.fromDateValue;
      let tDate = this.toDateValue;
      if (this.dateType == "month") {
        fDate = "01-" + fDate;
        tDate = "01-" + tDate;
      } else if (this.dateType == "year") {
        fDate = "01-01-" + fDate;
        tDate = "01-01-" + tDate;
      }
      profitAndLossService
        .getProfitAndLoss(fDate, tDate, this.branch, this.dateType)
        .then((data) => {
          this.profitAndLoss = data;
        });
    },
    onexport() {
      var excelList = [];
      var header = {};
      header.date = "Date";
      header.status = "Status";
      header.deliverName = "Name";
      header.times = "Amount";
      excelList.push(header);

      var reportList = this.profitAndLoss.profitLossList;
      for (var i = 0; i < reportList.length; i++) {
        var report = reportList[i];
        var date = report.reportTitle;
        var incomeList = report.incomeList;

        var data = {};
        data.date = date;
        data.status = "GrossProfit ";
        data.times = report.grossProfit;
        excelList.push(data);

        for (var k = 0; k < incomeList.length; k++) {
          var subReport = incomeList[k];
          var data = {};
          data.date = date;
          data.status = "Income";
          data.deliverName = subReport.typeName;
          data.times = subReport.amount;
          excelList.push(data);
        }

        var data = {};
        data.date = date;
        data.status = "TotalIncomePrice ";
        data.times = report.totalIncomePrice;
        excelList.push(data);

        var subReportList = report.expenseList;
        for (var j = 0; j < subReportList.length; j++) {
          var subReport = subReportList[j];
          var data = {};
          data.date = date;
          data.status = "Expend";
          data.deliverName = subReport.typeName;
          data.times = subReport.amount;
          excelList.push(data);
        }
        var data = {};
        data.date = date;
        data.status = "TotalExpensePrice";
        data.times = report.totalExpensePrice;
        excelList.push(data);

        var data = {};
        data.date = date;
        data.status = "Profit And Loss ";
        data.times = report.profitLoss;
        excelList.push(data);
      }

      var data = {};
      data.date = "Total ";
      data.status = this.profitAndLoss.totalProfitLoss;
      excelList.push(data);

      var pokemonWS = XLSX.utils.json_to_sheet(excelList, {
        skipHeader: true,
      });

      pokemonWS["!cols"] = [
        { width: 13 },
        { width: 20 },
        { width: 20 },
        { width: 10 },
      ];

      var workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, pokemonWS, "ProfitAndLoss");
      XLSX.writeFile(workbook, "ProfitAndLoss" + ".xlsx");
    },
  },
  computed: {
    toDateValue() {
      var toDatetemp = "";
      toDatetemp = this.formatDate(this.toDate);
      return toDatetemp;
    },
    fromDateValue() {
      var fromDatetemp = "";
      fromDatetemp = this.formatDate(this.fromDate);
      return fromDatetemp;
    },
  },
  watch: {
    dateType: function () {
      if (this.dateType != "year") {
        this.datePickerType = this.dateType;
      } else {
        this.datePickerType = "month";
      }
      //this.saleReportData.reportList = [];
      //this.saleReportData.total = 0;
    },
  },
};
</script>
<style scoped>
.fullscreen {
  height: 92vh;
}
</style>
